import React, { useState } from "react";

import {
    SovosToolbarGroup,
    SovosToolbarActions,
    SovosMenu,
    SovosMenuItem,
    SovosTypography,
    SovosBox,
    SovosIconButton,
    SovosLinearProgress,
} from "mosaic-react";
import { DefaultToolbar, DataGridTabs } from "colbi_web_ui/lib/components";
import { Download } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import Connect from "colbi_web_ui/lib/components/Connect";

const RawDataToolbar = ({ defaultToolbarProps, toolbarProps }) => {
    const { tabsProps } = toolbarProps;
    const { i18n, download, downloadableQueries, locale, downloadCsvStreamAction } = useGlobalValue();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleExport = (format) => {
        handleClose();
        if (format === "csv") {
            downloadCsvStreamAction && downloadCsvStreamAction(downloadableQueries, locale);
        } else {
            // xlsx format
            download && download(downloadableQueries, locale, null);
        }
    };

    return (
        <Connect to={["downloading"]}>
            {({ downloading }) => (
                <>
                    {downloading && (
                        <SovosBox
                            sx={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: "rgba(0, 0, 0, 0.3)",
                                zIndex: 1300,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <SovosBox
                                sx={{
                                    backgroundColor: "white",
                                    padding: "24px 48px",
                                    borderRadius: "8px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                                }}
                            >
                                <SovosLinearProgress sx={{ width: "200px", mb: 2 }} />
                                <SovosTypography variant="body1">{i18n`Downloading...`}</SovosTypography>
                            </SovosBox>
                        </SovosBox>
                    )}
                    <SovosToolbarGroup sx={{ width: "100%" }}>
                        <SovosToolbarGroup
                            sx={{ flex: "1 1 auto", justifyContent: "flex-start", paddingRight: "10px" }}
                        >
                            <DataGridTabs {...tabsProps} />
                        </SovosToolbarGroup>
                        <SovosToolbarGroup>
                            <SovosToolbarActions>
                                <SovosIconButton
                                    onClick={handleClick}
                                    aria-controls={open ? "export-menu" : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? "true" : undefined}
                                    disabled={downloading}
                                >
                                    <Download />
                                </SovosIconButton>
                                <SovosMenu
                                    id="export-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    MenuListProps={{
                                        "aria-labelledby": "export-button",
                                    }}
                                >
                                    <SovosMenuItem onClick={() => handleExport("xlsx")}>
                                        <SovosBox>
                                            <SovosTypography variant="body1" fontWeight="medium">
                                                {i18n`XLSX (Excel)`}
                                            </SovosTypography>
                                            <SovosTypography variant="caption" color="text.secondary">
                                                {i18n`Limit 120000 rows`}
                                            </SovosTypography>
                                        </SovosBox>
                                    </SovosMenuItem>
                                    <SovosMenuItem onClick={() => handleExport("csv")}>
                                        <SovosBox>
                                            <SovosTypography variant="body1" fontWeight="medium">
                                                {i18n`CSV`}
                                            </SovosTypography>
                                        </SovosBox>
                                    </SovosMenuItem>
                                </SovosMenu>
                                <DefaultToolbar {...defaultToolbarProps} />
                            </SovosToolbarActions>
                        </SovosToolbarGroup>
                    </SovosToolbarGroup>
                </>
            )}
        </Connect>
    );
};

export default RawDataToolbar;
